import { routesName } from 'core/src';
import { Container, ConversationScreen } from 'components/src';
import { StackScreenProps } from '@react-navigation/stack';
import { ParamList } from '../../app/RouteConfig/jsdoc';
import React, { memo } from 'react';

const Conversations = memo(
  ({ navigation }: StackScreenProps<ParamList, routesName.CONVERSATIONS>) => {
    return (
      <Container>
        <ConversationScreen navigation={navigation} />
      </Container>
    );
  },
);

export { Conversations };
